
<div class="page legacy-page overlayed" id="list-new-page">
    <div class="action-bar dark-bg">
        <div class="title no-margin">Crea una nueva Lista</div>
        <div class="actions-set">
            <div class="actions-set">
                <a class="action-btn done SaveBtn" href="#"></a>
                |
                <a class="action-btn delete" href="#"></a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
        </div>
    </div>
    <div class="page-overlay"></div>
    <div class="content">
        <div class="container legacy-container">
            <div class="section" id="nueva-lista">
                <form class="legacy-form" id="new-list-form">

                    <a class="action-btn CancelBtn" icon="cancel" href="#"></a>

                    <h2 class="StringCtrl required" property="title">
                        <input type="text" size=32 placeholder="Nombre ?"/>
                        <p class="hint">
                            Ingresa aquí un nombre descriptivo para la nueva <b>Lista</b>. 
                            Este campo es necesario.
                        </p>
                    </h2>

                    <ul>
                        <li class="StringCtrl" property="alias">
                            <label>Alias</label>
                            <input type="text" size=22/>
                            <p class="hint">
                                Se usará este alias para referirse a la lista.
                            </p>
                        </li>

                        <li class="CombinedCtrl">
                            <label>Tipo y estado :</label>
                            <div>
                            <span class="SelectCtrl" property="type">
                                <select name="type">
                                    <option value="E">Standard</option>
                                    <option value="R">Externa (SQL)</option>
                                    <!-- <option value="MO">Externa (Mongo)</option> -->
                                </select>
                            </span>
                            <span class="SelectCtrl" property="state">
                                <select name="state">
                                    <option value="A">Activa</option>
                                    <option value="I">Inactiva</option>
                                    <option value="X">Eliminada</option>
                                </select>
                            </span>
                            </div>
                        </li>
        
                        <li class="TextCtrl" property="descr">
                            <label>Descripción</label>
                            <textarea rows="1"></textarea>
                            <p class="hint">Breve descripción de la lista</p>
                        </li>
                    </ul>

                    <p class="form-buttons">
                        <button class="accept CreateBtn">AGREGAR AHORA</button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</div>


<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#list-new-page").ListNewPage("#nueva-lista");
  console.log("DONE: installed ListNewPage to hash '#nueva-lista'")
})
</script>
